import { AnalyticsService } from './../analytics/analytics.service';
import { Http, RequestOptions, Headers } from '@angular/http';
import { environment } from '../../environments/environment';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { Settings } from '../settings/settings';
import { Intercom } from 'ng-intercom';
import { ConfigurationService } from '../shared/configuration.service';

export class User {
  uid: string;
  email: string;
  photoURL?: string;
  displayName?: string;
  favoriteColor?: string;
  registryId?: string;
  dismissCreatePopup: boolean;
  stripeAccountId: string;
  secret: string;
  publishKey: string;
  emailVerified: boolean;
  dismissHelpGuide: boolean;
  userId: string;
  referalUserId: string;
  partnerEmail: string;
  fromAnonymous: boolean;

}
@Injectable()
export class AuthService {

  private userSource = new BehaviorSubject<User>(null);

  user: Observable<User>;
  constructor(private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router,
    private _intercom: Intercom,
    private http: Http,
    private _analyticsService: AnalyticsService
  ) {
    //// Get auth data, then get firestore user document || null
    this.user = this.afAuth.authState
      .switchMap(user => {

        if (user) {
          return this.afs.doc<User>(`users/${user.uid}`)
            .valueChanges()
            .map(userDoc => {
              if (userDoc) {
                userDoc.emailVerified = user.emailVerified;
                return userDoc;
              }
            });
        } else {
          return Observable.of(null);
        }
      });
  }

  authToken() {
    return this.afAuth.idToken;
  }

  forgotPassword(email: string, token:string) {
    
    const reqBody = JSON.stringify({
      email: email,
      token: token,
    });

    return this.http.post(environment.firebase.clouldFunctionHost + '/forgotPassword', reqBody, this.requestOptions())
    .map(response => {
      return response; })
      .catch(this.handleError).take(1).subscribe(x => {
        ;
        return;
      });


  }


  signup(email: string, password: string, isAnonymous = false): Promise<User> {
    const provider = new firebase.auth.EmailAuthProvider();
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password)
      .then((res) => {
        const user: User = new User();
        user.email = res.providerData[0].email;
        user.uid = res.uid;
        user.dismissCreatePopup = false;
        user.dismissHelpGuide = false;
        user.fromAnonymous = isAnonymous;
        this.addUserData(user).then(x => {
          if (!this._analyticsService.skipEuMarketing){
          this._intercom.boot({ email: user.email, name: null });
          }
        });


        return user;
      });
  }

  sendEmailVerification(email, uid) {

    const reqBody = JSON.stringify({
      email: email,
      verifyCode: uid,
      envProd: environment.production
    });

    // return this.http.post(environment.firebase.clouldFunctionHost + '/sendVerifyEmail', reqBody, this.requestOptions())
    //    .map(response => {
    //   return response; }).map(x=>{
    //
    //   });


      this.http.post(environment.firebase.clouldFunctionHost + '/sendVerifyEmail', reqBody, this.requestOptions())
      .map(response => {
        return response; })
        .catch(this.handleError).take(1).subscribe(x => {

        });



    }



    private handleError(error: Response | any) {
      // In a real world app, we might use a remote logging infrastructure
      let errMsg: string;
      if (error instanceof Response) {
        const body = error.json() || '';
        const err = body || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
      } else {
        errMsg = error.message ? error.message : error.toString();
      }

      return Observable.throw(errMsg);
    }


  private requestOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers});
    return options;
  }

  login(email: string, password: string): Promise<any> {
    const provider = new firebase.auth.EmailAuthProvider();


    return this.afAuth.auth.signInWithEmailAndPassword(email, password).then(credential => {


      this.afs.doc<User>(`users/${credential.uid}`).snapshotChanges().take(1).subscribe(userDoc => {

        if (!userDoc.payload.exists) {
          const user: User = new User();
          user.email = credential.providerData[0].email;
          user.uid = credential.uid;
          user.dismissCreatePopup = false;
          user.dismissHelpGuide = false;

          this.addUserData(user).then(x => {
            return user;
          });
        }
      });

    }).catch((error: any) => {
      if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
        throw new Error('authError');
      } else if (error.code) {
        throw new Error(error.code);
      }
    });

  }

  googleLogin(): Promise<any> {

    const provider = new firebase.auth.GoogleAuthProvider();
    return this.oAuthLogin(provider);

  }

  private oAuthLogin(provider): Promise<any> {
    //
    return this.afAuth.auth.signInWithPopup(provider).then((authUser: any) => {

      if (authUser && authUser.user) {
        const referal_user_id = localStorage.getItem('referal_id');
        this.afs.doc<User>(`users/${authUser.user.uid}`).valueChanges().take(1).subscribe((user: User) => {
          if (!user) {
            user = new User();
            user.email = authUser.user.providerData[0].email;
            user.uid = authUser.user.uid;
            user.dismissCreatePopup = false;
            user.dismissHelpGuide = false;

            if(referal_user_id){
              user.referalUserId = referal_user_id;
            }
          }


          return this.addUserData(user).then(x => {
            //
            return authUser.user;
          }).catch((err) => {
            //
console.log(err);
          });
        });
      }
    })
      .catch((error: any) => {

        if (error.code) {
          throw new Error(error.code);
        }
      });


  }

  facebookLogin(): Promise<any> {
    const provider = new firebase.auth.FacebookAuthProvider();
    return this.oAuthLogin(provider);
  }



  private addUserData(user: User): Promise<any> {
    user.userId = user.uid;
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    return userRef.set(JSON.parse(JSON.stringify(user)), { merge: true }).then(x => {
      return x;
    });
  }



  silentSignOut() {
    this.afAuth.auth.signOut().then(() => {
      this.router.navigate(['login']);
    });
    //   location.href = '/login';
  }

  signOutNoRedirect() {

    this.afAuth.auth.signOut().then(() => {
    

    });
    //    location.href = '/login';
  }
  signOut() {

    this.afAuth.auth.signOut().then(() => {
      window.location.href = "login";

    });
    //    location.href = '/login';
  }
}



// WEBPACK FOOTER //
// ./src/app/user/auth.service.ts